import { render, staticRenderFns } from "./registroPagosDetailInfo.vue?vue&type=template&id=4b592af3&scoped=true"
import script from "./registroPagosDetailInfo.vue?vue&type=script&lang=js"
export * from "./registroPagosDetailInfo.vue?vue&type=script&lang=js"
import style0 from "./registroPagosDetailInfo.vue?vue&type=style&index=0&id=4b592af3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b592af3",
  null
  
)

export default component.exports